module.exports = __webpack_public_path__ + "media/images/subnav-background-325a3670.png";